<ng-container *ngIf="dialogUnlocodeVisible">
    <app-unlocodepopup #unlocodePopup [idPais]="IdPaisDestino" [listPais]="listPais" (selected)="onSelectUnlocode($event)"></app-unlocodepopup>
</ng-container>

<form [formGroup]="form" (ngSubmit)="saveSolicitud()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinnerGuardar" [disabled]="!habilitarGuardar" (click)="saveSolicitud()" title="Guardar" type="button" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinnerGuardar" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>

            <button *ngIf="habilitarBotonCambiarPIF" (click)="onChangePuntoInspeccion()" type="button" class="btn btn-outline-success"><i class="fa fa-exchange" aria-hidden="true"></i> Cambiar PIF</button>

            <!--<button class="btn btn-outline-success" (click)="cargarDatosPrueba()"><i class="fa fa-long-arrow-up"></i> CARGAR DATOS</button>-->
            <button *ngIf="visibilityDatosSolicitud && !visibilitySpinnerInformeDatos" title="Informe Solicitud" type="button" class="btn btn-outline-success"
                    (click)="printDocumentoDatosSolicitudEx()">
                <i class="fa fa-file-pdf-o"></i> Informe Solicitud
            </button>
            <button *ngIf="visibilitySpinnerInformeDatos" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Generando Informe
            </button>

            <button *ngIf="visibilityResultadoInspeccion && !visibilitySpinnerInformeInspeccion" title="Resultado Inspección" type="button" class="btn btn-outline-success"
                    (click)="printDocumentoResultadoInspeccionEx()">
                <i class="fa fa-file-pdf-o"></i> Informe Inspección
            </button>
            <button *ngIf="visibilitySpinnerInformeInspeccion" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Generando Informe
            </button>

            <!-- BOTON GENERAR INFORME CERTIFICADO PREVIO EXPORTACION -->
            <!--<button *ngIf="!visibilitySpinnerDocumentoCertificadoPrevioExportacion" title="Resultado CPE" type="button" class="btn btn-outline-success"
            (click)="printDocumentoCertificadoPrevioExportacion()">
        <i class="fa fa-file-pdf-o"></i> Informe CPE
    </button>
    <button *ngIf="visibilitySpinnerDocumentoCertificadoPrevioExportacion" [disabled]="true" class="btn btn-outline-success">
        <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
        Generando Informe
    </button>-->
            <!-- FIN BOTON CPE -->
            <!--<button *ngIf="visibilityResultadoInspeccion && !visibilitySpinnerCertificadofitosanitario" title="Certificado Fitosanitario" type="button" class="btn btn-outline-success"
            (click)="printCertificadoFitosanitarioEx()">
        <i class="fa fa-file-pdf-o"></i> Certificado Fitosanitario
    </button>
    <button *ngIf="visibilitySpinnerCertificadofitosanitario" [disabled]="true" class="btn btn-outline-success">
        <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
        Generando Informe
    </button>-->
            <!--<button *ngIf="visibilityResultadoInspeccion && !visibilitySpinnerEphyto" title="Informe ePhyto" type="button" class="btn btn-outline-success"
            (click)="printEphyto()">
        <i class="fa fa-file-pdf-o"></i> Informe ePhyto
    </button>
    <button *ngIf="visibilitySpinnerEphyto" [disabled]="true" class="btn btn-outline-success">
        <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
        Generando Informe
    </button>-->

        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{editTitle}} Solicitud {{form.value.Codigo}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{form.value.IdTipoSolicitudEx | IconoTipoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />
                <img class="estado-icono-big" container="body" src="{{form.value.IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloEstadoSolicitudEx}}" />
                <img *ngIf="solicitudEx?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || solicitudEx?.IdSubTipoSolicitudEx === reExpConAtestFito || solicitudEx?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{solicitudEx.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{solicitudEx.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{form.value.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{tituloEstadoCertificadoFitoEx}}" />
                <img *ngIf="solicitudEx?.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{solicitudEx.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="idSolicitudEx">
                    <app-alertarechazo [id]="idSolicitudEx" [esExport]="true"></app-alertarechazo>
                </ng-container>

                <div class="row">
                    <!--CABECERA SOLICITUD-->
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn" style="margin-top: 3px">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Cabecera Solicitud
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">
                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">Punto de Inspección</label>
                                            <ng-select [items]="listPuntoInspeccion"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPuntoInspeccion"
                                                       loadingText="Cargando..."
                                                       [loading]="!listPuntoInspeccion"
                                                       notFoundText="Punto de Inspección no encontrado"
                                                       placeholder="-- Seleccione un Punto de Inspección --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdPuntoInspeccion')"
                                                       (change)="onSelectPuntoInspeccion()">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPuntoInspeccion','required')">
                                                Punto de Inspección es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">Ref. Solicitante</label>
                                            <input formControlName="RefSolicitante" name="RefSolicitante" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="50">
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoUbicacion }" for="">Ubicación</label>
                                            <ng-select [items]="listUbicacion"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdUbicacion"
                                                       loadingText="Cargando..."
                                                       [loading]="(!listUbicacion && (form.value.IdPuntoInspeccion > 0))"
                                                       notFoundText="Ubicación no encontrada"
                                                       placeholder="-- Seleccione una Ubicación --"
                                                       [ngClass]="displayFieldCssNgSelect('IdUbicacion')"
                                                       clearAllText="Eliminar selección"
                                                       (change)="onSelectUbicacion()">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdUbicacion','required')">
                                                La ubicación es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoInstalacion }"for="">Instalación Autorizada</label>
                                            <ng-select [items]="listInstalacionAutorizada"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdInstalacionAutorizada"
                                                       loadingText="Cargando..."
                                                       [loading]="(!listInstalacionAutorizada && (form.value.IdPuntoInspeccion > 0))"
                                                       notFoundText="Instalación Autorizada no encontrada"
                                                       placeholder="-- Seleccione una Instalación Autorizada --"
                                                       [ngClass]="displayFieldCssNgSelect('IdInstalacionAutorizada')"
                                                       clearAllText="Eliminar selección"
                                                       (change)="onSelectInstalacionAutorizada()">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdInstalacionAutorizada','required')">
                                                Instalación Autorizada es obligatoria
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <!--SOLICITANTE-->
                        <div class="card card-accent-success animated fadeIn" *ngIf="!esSolicitudGrabador">
                            <a class="card-header-a" (click)="isCollapsedSolicitante = !isCollapsedSolicitante" [attr.aria-expanded]="!isCollapsedSolicitante" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Solicitante
                                    <i *ngIf="isCollapsedSolicitante" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedSolicitante" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedSolicitante" [ngbCollapse]="isCollapsedSolicitante">
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="">Razón Social</label>
                                            <div class="input-group">
                                                <input readonly formControlName="RazonSocial" name="RazonSocial" title="" class="form-control" id="inpNombre" type="text" value="">
                                                <span *ngIf="enviada" class="input-group-btn">
                                                    &nbsp;<button name="btnShowSolicitante" class="btn btn-list btn-secondary" type="button" title="Ver datos Solicitante" (click)="onShowSolicitante()"><i class="fa fa-search"></i></button>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">NIF</label>
                                            <input readonly formControlName="NifSolicitante" name="NifSolicitante" title="" class="form-control" id="inpDireccion" type="text" value="">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">Teléfono</label>
                                            <input readonly formControlName="NumeroTelefono" name="NumeroTelefono" title="" class="form-control" id="inpDireccion" type="text" value="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <!--SOLICITANTE ADMINISTRATIVO-->
                        <div class="card card-accent-success animated fadeIn" *ngIf="esSolicitudGrabador">
                            <a class="card-header-a" (click)="isCollapsedSolicitanteAdministrativo = !isCollapsedSolicitanteAdministrativo" [attr.aria-expanded]="!isCollapsedSolicitanteAdministrativo" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Solicitante
                                    <i *ngIf="isCollapsedSolicitanteAdministrativo" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedSolicitanteAdministrativo" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedSolicitanteAdministrativo" [ngbCollapse]="isCollapsedSolicitanteAdministrativo">
                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">NIF</label>
                                            <div class="input-group">
                                                <input formControlName="NifSolicitanteAdministrativo" name="NifSolicitanteAdministrativo" title="" class="form-control" maxlength="9"
                                                       [ngClass]="displayFieldCss('NifSolicitanteAdministrativo')" id="" type="text" value="">
                                                <span class="input-group-btn">
                                                    &nbsp;<button name="btnSearchNifSolicitanteAdministrativo" class="btn btn-list btn-secondary" type="button" title="Buscar NIF" (click)="onSearchNifSolicitanteAdministrativo()"><i class="fa fa-search"></i></button>
                                                </span>
                                            </div>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifSolicitanteAdministrativo','required')">
                                                NIF es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifSolicitanteAdministrativo','NIF')">
                                                Formato de NIF incorrecto
                                            </div>
                                        </div>
                                        <div class="form-group col-md-5">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Razón Social</label>
                                            <input [readonly]="!habilitarSolicitanteAdministrativo" formControlName="RazonSocialSolicitanteAdministrativo" name="RazonSocialSolicitanteAdministrativo"
                                                   title="" class="form-control" [ngClass]="displayFieldCss('RazonSocialSolicitanteAdministrativo')" id="" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('RazonSocialSolicitanteAdministrativo','required')">
                                                Razón Social es obligatorio
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Teléfono</label>
                                            <input [readonly]="!habilitarSolicitanteAdministrativo" formControlName="NumeroTelefonoSolicitanteAdministrativo" name="NumeroTelefonoSolicitanteAdministrativo"
                                                   title="" class="form-control" [ngClass]="displayFieldCss('NumeroTelefonoSolicitanteAdministrativo')" id="" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NumeroTelefonoSolicitanteAdministrativo','required')">
                                                Número Teléfono es obligatorio
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <!--EXPORTADOR-->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedExportador = !isCollapsedExportador" [attr.aria-expanded]="!isCollapsedExportador" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Exportador
                                    <i *ngIf="isCollapsedExportador" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedExportador" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedExportador" [ngbCollapse]="isCollapsedExportador">
                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">NIF / EORI </label>
                                            <div class="input-group">
                                                <input formControlName="NifExportador" name="NifExportador" title="" class="form-control" maxlength="17"
                                                       [ngClass]="displayFieldCss('NifExportador')" id="" type="text" value="">
                                            </div>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifExportador','required')">
                                                NIF es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifExportador','NIF')">
                                                Formato de NIF incorrecto
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Nombre</label>
                                            <input formControlName="NombreExportador" name="NombreExportador" [ngClass]="displayFieldCss('NombreExportador')" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="300">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreExportador','required')">
                                                Nombre es obligatorio
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="intEstado">País</label>
                                            <ng-select [items]="listPais"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPaisExportador"
                                                       loadingText="Cargando..."
                                                       [loading]="!(listPais)"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       [ngClass]="displayFieldCssNgSelect('IdPaisExportador')"
                                                       clearAllText="Eliminar selección"
                                                       (change)="onSelectPaisExportador()">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>

                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisExportador','required')">
                                                País es obligatorio
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Ciudad</label>
                                            <input formControlName="LocalidadExportador" name="LocalidadExportador" [ngClass]="displayFieldCss('LocalidadExportador')" title="" class="form-control" id="inpCiudad" type="text" value="" maxlength="100">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('LocalidadExportador','required')">
                                                Ciudad es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Dirección</label>
                                            <input formControlName="DireccionExportador" name="DireccionExportador" [ngClass]="displayFieldCss('DireccionExportador')" title="" class="form-control" id="inpDireccion" type="text" value="" maxlength="250">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('DireccionExportador','required')">
                                                Dirección es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpCodigoPostal" [ngClass]="{ 'required-field' : usaCodigoPostalPaisExportador && campoObligatorio }">Código Postal</label>
                                            <input class="form-control" formControlName="CodigoPostalExportador" maxlength="15"
                                                   inputStyleClass="form-control" id="inpCodPostalExportador" value="" [ngClass]="displayFieldCss('CodigoPostalExportador')">
                                            <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostalExportador','pattern')">
                                                Formato incorrecto
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoPostalExportador','required')">
                                                El Código Postal es obligatorio
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <!--DESTINATARIO-->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedDestinatario = !isCollapsedDestinatario" [attr.aria-expanded]="!isCollapsedDestinatario" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Destinatario
                                    <i *ngIf="isCollapsedDestinatario" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDestinatario" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDestinatario" [ngbCollapse]="isCollapsedDestinatario">
                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Nombre</label>
                                            <input formControlName="NombreDestinatario" name="NombreDestinatario" [ngClass]="displayFieldCss('NombreDestinatario')" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="300">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreDestinatario','required')">
                                                Nombre es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">NIF</label>
                                            <div class="input-group">
                                                <input formControlName="NifDestinatario" name="NifDestinatario" title="" class="form-control" maxlength="50" id="" type="text" value="">
                                            </div>

                                            <!--<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifDestinatario','required')">
                                    NIF es obligatorio
                                </div>-->
                                            <!--<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NifDestinatario','NIF')">
                                     Formato de NIF incorrecto
                                 </div>-->
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="intEstado">País</label>
                                            <ng-select [items]="listPais"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPaisDestinatario"
                                                       loadingText="Cargando..."
                                                       [loading]="!(listPais)"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       [ngClass]="displayFieldCssNgSelect('IdPaisDestinatario')"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>

                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisDestinatario','required')">
                                                País es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Ciudad</label>
                                            <input formControlName="CiudadDestinatario" name="CiudadDestinatario" [ngClass]="displayFieldCss('CiudadDestinatario')" title="" class="form-control" id="inpCiudad" type="text" value="" maxlength="100">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CiudadDestinatario','required')">
                                                Ciudad es obligatoria
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Dirección</label>
                                            <input formControlName="DireccionDestinatario" name="DireccionDestinatario" [ngClass]="displayFieldCss('DireccionDestinatario')" title="" class="form-control" id="inpDireccion" type="text" value="" maxlength="250">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('DireccionDestinatario','required')">
                                                Dirección es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpCodigoPostal">Código Postal</label>
                                            <input class="form-control" formControlName="CodigoPostalDestinatario" maxlength="15"
                                                   inputStyleClass="form-control" id="inpCodPostalDestinatario" value="">
                                            <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostalDestinatario','pattern')">
                                                Formato incorrecto
                                            </div>
                                            <!--<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoPostalDestinatario','required')">
                                    El Código Postal es obligatorio
                                </div>-->

                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">Nº Permiso Importación (AFIDI, etc.)</label>
                                            <input formControlName="NumeroAfidi" name="NumeroAfidi" title="" class="form-control" id="inpDireccion" type="text" value="" maxlength="50">

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <!--LUGARES REFERENTES A LA MERCANCIA-->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedLugaresMercancia = !isCollapsedLugaresMercancia" [attr.aria-expanded]="!isCollapsedLugaresMercancia" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Lugares referentes a la mercancía
                                    <i *ngIf="isCollapsedLugaresMercancia" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedLugaresMercancia" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedLugaresMercancia" [ngbCollapse]="isCollapsedLugaresMercancia">
                                    <div class="row">
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="intPais">País de Destino</label>
                                            <ng-select [items]="listPaisesExpor"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPaisDestino"
                                                       loadingText="Cargando..."
                                                       [loading]="!listPaisesExpor"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       [ngClass]="displayFieldCssNgSelect('IdPaisDestino')"
                                                       (change)="onChangePaisDestino()"
                                                       clearAllText="Eliminar selección">
                                            </ng-select>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisDestino','required')">
                                                País de Destino es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="inpPaisPuntoEntrada">País Punto de Entrada</label>
                                            <div class="input-group">
                                                <input formControlName="PaisPuntoEntradaUnlocode" readonly name="PaisPuntoEntradaUnlocode" [ngClass]="displayFieldCss('PaisPuntoEntradaUnlocode')" class="form-control" id="inpPaisPuntoEntrada" type="text" maxlength="250">
                                                <span class="input-group-btn">
                                                    &nbsp;<button name="btnSearchUnlocode" class="btn btn-list btn-secondary" type="button" [disabled]="!habilitarGuardar" title="Buscador Unlocode" (click)="onSearchUnlocode()">
                                                        <i class="fa fa-search"></i>
                                                    </button>
                                                </span>
                                            </div>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('PaisPuntoEntradaUnlocode','required')">
                                                Pais Punto de Entrada es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-5">
                                            <label class="col-form-label required-field" for="inpPuntoEntrada">Punto de Entrada</label>
                                            <input formControlName="PuntoEntrada" readonly name="PuntoEntrada" [ngClass]="displayFieldCss('PuntoEntrada')" title="" class="form-control" id="inpPuntoEntrada" type="text" value="" maxlength="250">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('PuntoEntrada','required')">
                                                Punto de Entrada es obligatorio
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="intPais">País de Origen</label>
                                            <ng-select [items]="listPaisesExpor"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPaisOrigen"
                                                       loadingText="Cargando..."
                                                       [loading]="!listPaisesExpor"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       [ngClass]="displayFieldCssNgSelect('IdPaisOrigen')"
                                                       clearAllText="Eliminar selección">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisOrigen','required')">
                                                País de Origen es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">Lugar de Origen</label>
                                            <input formControlName="LugarOrigen" name="LugarOrigen" title="" class="form-control" id="inpDireccion" type="text" value="" maxlength="50">

                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpFecha">Fecha Inspección</label>
                                            <p-calendar formControlName="FechaInspeccion" inputStyleClass="form-control"
                                                        [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>

                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">Hora Inspección</label>
                                            <ng-select [items]="listIntervalo"
                                                       bindLabel="HoraInicio"
                                                       bindValue="Id"
                                                       formControlName="IdIntervaloHoras"
                                                       loadingText="Cargando..."
                                                       [loading]="(!listIntervalo && (form.value.IdPuntoInspeccion > 0))"
                                                       notFoundText="Hora no encontrada"
                                                       placeholder="-- Seleccione Hora --"
                                                       clearAllText="Eliminar selección">
                                            </ng-select>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <!--MEDIOS DE TRANSPORTE-->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedMediosTransporte = !isCollapsedMediosTransporte" [attr.aria-expanded]="!isCollapsedMediosTransporte" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Medios de transporte
                                    <i *ngIf="isCollapsedMediosTransporte" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedMediosTransporte" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedMediosTransporte" [ngbCollapse]="isCollapsedMediosTransporte">
                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Tipo</label>
                                            <ng-select [items]="listMedioTransporte"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdMedioTransporte"
                                                       loadingText="Cargando..."
                                                       [loading]="!listMedioTransporte"
                                                       notFoundText="Tipo no encontrado"
                                                       placeholder="-- Seleccione un Tipo --"
                                                       [ngClass]="displayFieldCssNgSelect('IdMedioTransporte')"
                                                       clearAllText="Eliminar selección"
                                                       (change)="onSelectTipoMedioTransporte()">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdMedioTransporte','required')">
                                                Tipo es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="">En:</label>
                                            <ng-select [items]="listTipoEnvio"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdTipoEnvio"
                                                       loadingText="Cargando..."
                                                       [loading]="!listTipoEnvio"
                                                       notFoundText="Tipo de Envío no encontrado"
                                                       placeholder="-- Seleccione un Tipo de Envío --"
                                                       clearAllText="Eliminar selección">
                                            </ng-select>

                                        </div>

                                        <div class="form-group col-md-4">
                                            <!-- Todo:agaro. 03052022. Se quita de ser obligatorio el Buque/Awb [ngClass]="{ 'required-field' : campoObligatorio }"-->
                                            <label class="col-form-label" for="">Buque/Matrícula/AWB</label>
                                            <input formControlName="NumeroOMI" name="NumeroOMI" title="" maxlength="50" [ngClass]="displayFieldCss('NumeroOMI')"
                                                   class="form-control" id="" type="search" value="">

                                            <!--<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NumeroOMI','required')">
                                    Buque/Matrí­cula/AWB es obligatorio
                                </div>-->
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <!--SOLICITUD EN PAPEL (GRABADOR)-->
                        <div class="card card-accent-success animated fadeIn" *ngIf="esSolicitudGrabador">
                            <a class="card-header-a" (click)="isCollapsedDatosPapel = !isCollapsedDatosPapel" [attr.aria-expanded]="!isCollapsedDatosPapel" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos solicitud en papel
                                    <i *ngIf="isCollapsedDatosPapel" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosPapel" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDatosPapel" [ngbCollapse]="isCollapsedDatosPapel">
                                    <div class="row">
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="inpFecha">Fecha Registro</label>
                                            <p-calendar formControlName="FechaRegistro" inputStyleClass="form-control" [ngClass]="displayFieldCssCal('FechaRegistro')"
                                                        [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaRegistro','required')">
                                                Fecha Registro es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="">Nº Registro Papel</label>
                                            <input formControlName="NRegistroPapel" name="NRegistroPapel" title="" maxlength="20" class="form-control" id="" type="text" value="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <!--DATOS DEL ENVíO DE LA SOLICITUD-->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedDatosEnvio = !isCollapsedDatosEnvio" [attr.aria-expanded]="!isCollapsedDatosEnvio" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos del envío de la solicitud
                                    <i *ngIf="isCollapsedDatosEnvio" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosEnvio" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros-cf" id="collapsedDatosEnvio" [ngbCollapse]="isCollapsedDatosEnvio">
                                    <div class="row" *ngIf="solicitudEnviada">
                                        <div class="form-group col-md-2">
                                            <label class="col-form-label" for="inpFecha">Fecha Envío: </label>
                                            <input formControlName="FechaEnvio" name="FechaEnvio" readonly title="" class="form-control" id="" value="">
                                        </div>
                                        <div class="form-group col-md-2">
                                            <label class="col-form-label" for="inpFecha">Hora Envío: </label>
                                            <input formControlName="HoraEnvio" name="HoraEnvio" readonly title="" class="form-control" id="" value="">
                                        </div>
                                        <div class="form-group col-md-2">
                                            <label class="col-form-label" for="inpFecha">Número de Solicitud: </label>
                                            <input formControlName="Codigo" name="Codigo" readonly title="" class="form-control" id="" type="text" value="">
                                        </div>
                                        <div *ngIf="esPrevia" class="form-group col-md-2">
                                            <label class="col-form-label" for="inpFecha">Fecha Presentación: </label>
                                            <input formControlName="FechaPresentacion" name="FechaPresentacion" readonly title="" class="form-control" id="" value="">
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="!solicitudEnviada">
                                        <div class="form-group col-md-12" style="margin-bottom: 0px !important;">
                                            <label class="col-form-label" style="top: 12px;"><b> Solicitud pendiente de envío </b></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <!--DATOS DEL CERTIFICADO FITOSANITARIO-->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedDatosCF = !isCollapsedDatosCF" [attr.aria-expanded]="!isCollapsedDatosCF" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos Certificado Fitosanitario
                                    <i *ngIf="isCollapsedDatosCF" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosCF" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros-cf" id="collapsedDatosCF" [ngbCollapse]="isCollapsedDatosCF">
                                    <div class="row" *ngIf="hayNumeroCertificado">
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpFecha">Fecha Certificación: </label>
                                            <input formControlName="FechaCertificacion" name="FechaCertificacion" readonly title="" class="form-control" id="" value="">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpFecha">Número de Certificado: </label>
                                            <input formControlName="NumeroCertificado" name="NumeroCertificado" readonly title="" class="form-control" id="" type="text" value="">
                                        </div>
                                        <div class="form-group col-md-2" *ngIf="solicitudEx?.TClaveCertCanarias !== null && solicitudEx?.TClaveCertCanarias.Pin !== null">
                                            <label class="col-form-label" for="">PIN: </label>
                                            <input formControlName="Pin" name="Pin" readonly title="" class="form-control" id="" type="text" value="">
                                        </div>
                                        <div class="form-group col-md-2">
                                            <label class="col-form-label" for="inpIdiomaDescripcion">Idioma</label>
                                            <input formControlName="IdiomaDescripcion" name="IdiomaDescripcion" readonly title="" class="form-control" id="inpIdiomaDescripcion" type="text" value="">
                                        </div>
                                        <div class="form-group col-md-2">
                                            <label class="col-form-label" for="">ePhyto</label>
                                            <p-toggleButton class="togglebutton-integrado form-control-togglebutton" formControlName="EsEphyto" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="!hayNumeroCertificado">
                                        <div class="form-group col-md-12" style="margin-bottom: 0px !important;">
                                            <label class="col-form-label" style="top: 12px;"><b> Certificado Fitosanitario pendiente de emisión y aprobación </b></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <!--TERMINOS Y CONDICIONES-->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedTerminosCondiciones = !isCollapsedTerminosCondiciones" [attr.aria-expanded]="!isCollapsedTerminosCondiciones" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Términos y Condiciones *
                                    <i *ngIf="isCollapsedTerminosCondiciones" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedTerminosCondiciones" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="empty-grid" style="padding-left: 0px !important">Debe marcar al menos una de las siguientes casillas:</div>
                                <div class="collapse group-filtros" id="collapsedTerminosCondiciones" [ngbCollapse]="isCollapsedTerminosCondiciones">
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="">Permiso o Licencia de Importación</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="PermisoOLicenciaImp" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="">Normativa Fitosanitaria vigente del país de destino</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="NormativaFito" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="">El exportador o su representante declara que:</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="AceptarDeclaracion" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-12">
                                            <label class="col-form-label" for="inpFecha">* Ha sido informado que es su responsabilidad conocer los requisitos fitosanitarios exigidos en el país de destino. </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-12">
                                            <label class="col-form-label" for="inpFecha">* Ha sido informado que es necesario aportar la justificación de los requisitos fitosanitarios en destino, con objeto de evitar cualquier perjuicio al exportador; aportando el permiso o licencia previa de importación o cualquier figura asimilable, o la normativa fitosanitaria vigente en el país de destino. </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-12">
                                            <label class="col-form-label" for="inpFecha">* En caso de no aportar la documentación anteriormente referida, asume la responsabilidad de los perjuicios derivados de esta exportación en caso de que las autoridades fitosanitarias del tercer país impongan restricciones o exijan requisitos fitosanitarios adicionales al ingreso de la mercancía en su territorio. </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

</form>
